(function(){

    'use strict';

    var applicant_filtering = {
            'init' : function(){
                $('body').on('click', '.applicant-search-filtering__toggle', applicant_filtering.toggle);

            },
            'toggle' : function(e){
                e.preventDefault();
                var display = $('.applicant-search-filtering__display');
                if(display.hasClass('active')){
                    display.removeClass('active');
                } else {
                    display.addClass('active');
                }
            }
    };

    $(document).ready(function(){
        applicant_filtering.init();
    });

}());
